import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import getGroupedSkills from "../../utils/getUniqueSkills";

const grouped = getGroupedSkills();

const SkillsSection = ({ onSkillHover, hoveredSkill }) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <section className="pb-3">
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="flex items-center gap-2 w-full text-left mb-2"
        >
          <h2
            className="text-xl font-bold"
            style={{ color: "var(--text-primary)" }}
          >
            Skills
          </h2>
          <span
            className="text-xs transition-transform duration-200"
            style={{
              color: "var(--text-tertiary)",
              transform: collapsed ? "rotate(-90deg)" : "rotate(0deg)",
            }}
          >
            ▼
          </span>
        </button>

        <AnimatePresence initial={false}>
          {!collapsed && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="overflow-hidden"
            >
        <div className="space-y-1.5">
          {Object.entries(grouped).map(([category, skills]) => (
            <div key={category} className="flex items-baseline gap-2">
              <p
                className="text-xs shrink-0 w-20"
                style={{ color: "var(--text-tertiary)" }}
              >
                {category}
              </p>
              <div className="flex flex-wrap gap-1">
                {skills.map((skill) => (
                  <span
                    key={skill}
                    className="px-2 py-0.5 rounded text-xs cursor-default transition-all duration-200"
                    style={{
                      backgroundColor: hoveredSkill === skill
                        ? "rgba(255, 255, 255, 0.12)"
                        : "rgba(255, 255, 255, 0.04)",
                      color: hoveredSkill === skill
                        ? "#fff"
                        : "rgba(200, 210, 230, 0.8)",
                      border: hoveredSkill === skill
                        ? "1px solid rgba(255, 255, 255, 0.2)"
                        : "1px solid rgba(255, 255, 255, 0.06)",
                      opacity: hoveredSkill && hoveredSkill !== skill ? 0.3 : 1,
                    }}
                    onMouseEnter={() => onSkillHover(skill)}
                    onMouseLeave={() => onSkillHover(null)}
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </section>
  );
};

export default SkillsSection;
